<template>
  <div class="OwnerEvaluation">
    <div class="index-header">
      <div class="head-left">
        <span class="title">
          <i class="el-icon-caret-right"></i>
          评价概况
        </span>
        <span class="other more" @click="jumpMore(false)">
          更多
          <i class="el-icon-d-arrow-right"></i>
        </span>
      </div>
      <!-- <div class="head-right">
        <span class="head-right-left">全市物业企业评价前五:</span>
        <span class="head-right-right" @click="jumpMore">全市业主委员会评价前五:</span>
        <span class="other more" @click="jumpMore">
          更多
          <i class="el-icon-d-arrow-right"></i>
        </span>
      </div>-->
    </div>
    <div class="container ub ub-ac">
      <div class="articalTitle">
        <div class="articalTitle-child" @click="toOrgRankState">
          <!-- @click="toOrgRankState" -->
          <div class="num" style="cursor:pointer;">{{evaluateEaAreaCount}}个</div>
          <div class="artical">物业区域</div>
        </div>
        <div class="articalTitle-child" @click="toOrgRankState">
          <div class="num" style="cursor:pointer;">{{evaluateRealtyMgeComCount}}个</div>
          <div class="artical">物业企业</div>
        </div>
        <div class="articalTitle-child" @click="toOrgRankState">
          <div class="num" style="cursor:pointer;">{{evaluateOwnerTeamCount}}个</div>
          <div class="artical">业委会</div>
        </div>
        <div class="articalTitle-child" @click="jumpMore(false)">
          <div
            class="num"
            style="cursor:pointer;"
          >{{evaluateOwnerCount>10000?evaluateOwnerCount/10000+'万':evaluateOwnerCount}}人</div>
          <div class="artical">业主</div>
        </div>
        <div class="articalTitle-child" @click="toOrgScoreRank">
          <div class="warn">{{blackCount}}个</div>
          <div class="artical">连续六月倒数</div>
        </div>
      </div>
      <div class="box">
        <div class="box-right">
          <div ref="echarsDemo2" class="echarsDemo"></div>
          <div ref="echarsDemo1" class="echarsDemo"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      blackCount: 0,
      evaluateEaAreaCount: 0,
      evaluateOwnerCount: 0,
      evaluateOwnerTeamCount: 0,
      evaluateRealtyMgeComCount: 0,
      ownerRateList: [],
      ownerTeamRateList: [],
      ownerTeamScoreList: [],
      realtyMgeComScoreList: [],
      realtyMgeOrgRateList: [],
      realtyMgeOrgScoreList: [],
      month: [],
      index: 0
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.HomeControllerSvr = new HomeControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  updated() {
    this.getEchar1(this.$refs.echarsDemo1);
    this.getEchar2(this.$refs.echarsDemo2);
  },
  methods: {
    linkOwnerEvaluationList() {
      // this.$router.push('/ownerEvaluationList');
      this.$router.push({
        path: '/ownerEvaluationList',
        query: {
          isBoolType: 1,
        }
      });
    },
    linkTo() {
      this.$router.push('/institutionsEvaluation');
    },
    toOrgScoreRank() {
      this.$router.push('/orgScoreRank');
    },
    toOrgRankState() {
      this.$router.push('/orgRankStates');
    },
    getdata() {
      this.HomeControllerSvr.GetEvaluteProfile(this.token).then(res => {
        this.blackCount = res.blackCount;
        this.evaluateEaAreaCount = res.evaluateEaAreaCount;
        this.evaluateOwnerCount = res.evaluateOwnerCount;
        this.evaluateOwnerTeamCount = res.evaluateOwnerTeamCount;
        this.evaluateRealtyMgeComCount = res.evaluateRealtyMgeComCount;
        //生成x坐标
        // this.month = Object.keys(res.ownerTeamRateList).reverse();

        //得到每一项数据
        for (const key in res.ownerTeamRateList) {
          this.month.push(key);
          if (res.ownerTeamRateList.hasOwnProperty(key)) {
            const element = res.ownerTeamRateList[key];
            this.ownerTeamRateList.push(element);
          }
        }
        this.month;
        this.ownerTeamRateList;
        //得到每一项数据
        for (const key in res.ownerRateList) {
          if (res.ownerRateList.hasOwnProperty(key)) {
            const element = res.ownerRateList[key];
            this.ownerRateList.push(element);
          }
        }
        this.ownerRateList;
        //得到每一项数据
        for (const key in res.ownerTeamScoreList) {
          if (res.ownerTeamScoreList.hasOwnProperty(key)) {
            const element = res.ownerTeamScoreList[key];
            this.ownerTeamScoreList.push(element);
          }
        }
        this.ownerTeamScoreList;
        //得到每一项数据
        for (const key in res.realtyMgeComScoreList) {
          if (res.realtyMgeComScoreList.hasOwnProperty(key)) {
            const element = res.realtyMgeComScoreList[key];
            this.realtyMgeComScoreList.push(element);
          }
        }
        this.realtyMgeComScoreList;
        //得到每一项数据
        for (const key in res.realtyMgeOrgRateList) {
          if (res.realtyMgeOrgRateList.hasOwnProperty(key)) {
            const element = res.realtyMgeOrgRateList[key];
            this.realtyMgeOrgRateList.push(element);
          }
        }
        this.realtyMgeOrgRateList;
        //得到每一项数据
        for (const key in res.realtyMgeOrgScoreList) {
          if (res.realtyMgeOrgScoreList.hasOwnProperty(key)) {
            const element = res.realtyMgeOrgScoreList[key];
            this.realtyMgeOrgScoreList.push(element);
          }
        }
        this.realtyMgeOrgScoreList;
        this.getEchar1(this.$refs.echarsDemo1);
        this.getEchar2(this.$refs.echarsDemo2);
      });
    },
    getEchar1(dom) {
      let echarDom = this.$echarts.init(dom);
      let option = {
        title: {
          text: '参评率',
          textStyle: { fontSize: 13 },
          top: 0,
          left: 100
        },
        tooltip: {
          trigger: 'axis',
          // position: function(p) {
          //   //其中p为当前鼠标的位置
          //   return [p[0] + 10, p[1] - 10];
          // }
          position: function(point, params, dom, rect, size) {
            var tipHeight = point[1] + size.contentSize[1]; // contentSize: 提示dom 窗口大小
            var tipWeight = point[0] + size.contentSize[0]; // contentSize: 提示dom 窗口大小

            if (tipWeight > size.viewSize[0]) {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [
                  point[0] - size.contentSize[0],
                  point[1] - size.contentSize[1]
                ];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] - size.contentSize[0], point[1]];
              }
            } else {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [point[0] + 20, point[1] - size.contentSize[1]];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] + 20, point[1]];
              }
            }
          }
        },
        color: ['#fec553', '#0e76f1', '#ee6260'],
        legend: {
          data: ['物业机构', '业委会', '业主'],
          top: 18,
          left: 50,
          itemWidth: 14,
          itemHeight: 7
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.month
        },
        yAxis: {
          name: '',
          nameGap: 5,
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: { formatter: '{value}%' }
        },
        series: [
          {
            name: '物业机构',
            type: 'line',

            label: {
              normal: {
                show: false
              }
            },
            data: this.realtyMgeOrgRateList
          },
          {
            name: '业委会',
            type: 'line',

            label: {
              normal: {
                show: false
              }
            },
            data: this.ownerTeamRateList
          },
          {
            name: '业主',
            type: 'line',
            label: {
              normal: {
                show: false
              }
            },
            data: this.ownerRateList
          }
        ]
      };
      echarDom.getZr().on('click', params => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (echarDom.containPixel('grid', pointInPixel)) {
          this.linkTo();
        }
      });
      echarDom.setOption(option);
    },
    getEchar2(dom) {
      let echarDom = this.$echarts.init(dom);
      let option = {
        title: {
          text: '平均得分',
          top: 0,
          left: 100,
          textStyle: {
            fontSize: 13 //主题文字字体大小，默认为18px
          }
        },
        tooltip: {
          trigger: 'axis',
          // position: function(p) {
          //   //其中p为当前鼠标的位置
          //   return [p[0] + 10, p[1] - 10];
          // },
          position: function(point, params, dom, rect, size) {
            var tipHeight = point[1] + size.contentSize[1]; // contentSize: 提示dom 窗口大小
            var tipWeight = point[0] + size.contentSize[0]; // contentSize: 提示dom 窗口大小

            if (tipWeight > size.viewSize[0]) {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [
                  point[0] - size.contentSize[0],
                  point[1] - size.contentSize[1]
                ];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] - size.contentSize[0], point[1]];
              }
            } else {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [point[0] + 20, point[1] - size.contentSize[1]];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] + 20, point[1]];
              }
            }
          }
        },
        color: ['#fec553', '#0e76f1', '#ee6260'],
        legend: {
          data: ['物业企业', '物业机构', '业委会'],
          top: 18,
          left: 20,
          itemWidth: 14,
          itemHeight: 7
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.month
        },
        yAxis: {
          type: 'value',
          name: '',
          nameGap: 5,
          min: 0,
          max: 100
        },
        series: [
          {
            name: '物业企业',
            type: 'line',

            label: {
              normal: {
                show: false
              }
            },
            data: this.realtyMgeComScoreList
          },
          {
            name: '物业机构',
            type: 'line',

            label: {
              normal: {
                show: false
              }
            },
            data: this.realtyMgeOrgScoreList
          },
          {
            name: '业委会',
            type: 'line',

            label: {
              normal: {
                show: false
              }
            },
            data: this.ownerTeamScoreList
          }
        ]
      };
      echarDom.getZr().on('click', params => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (echarDom.containPixel('grid', pointInPixel)) {
          this.linkOwnerEvaluationList();
        }
      });
      echarDom.setOption(option);
    },
    forwordtorecord() {
      this.$router.push({ path: 'recordMge' });
    },
    forword() {
      this.$router.push({ path: 'equAdministration' });
    },
    jumpMore(bool) {
      // this.$message('该功能正在开发中');
      // this.$router.push({
      //   path: 'OwnerEvaluationStatistics',
      //   query: {
      //     args: bool //true表更多  false单个业主
      //   }
      // });
      this.$router.push({
        path: '/OwnerEvaluationStatistics'
      });
    },
    forwordAlltoarea() {
      this.$router.push({
        path: 'queryPropertyArea'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.OwnerEvaluation {
  background: #fff;
  .index-header {
    .head-left,
    .head-right {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .container {
    height: 260px;
    overflow: auto;
    .articalTitle {
      min-width: 450px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      padding: 5px 20px;
      border-bottom: 1px dotted #b7b7b7;
      margin: 0 auto;
      width: 95%;
      .num {
        font-size: 15px;
        font-weight: bold;
        color: #0f77f2;
      }
      .artical {
        color: #666666;
      }
      .warn {
        font-size: 15px;
        font-weight: bold;
        cursor: pointer;
        color: #ff4546;
      }
    }
    .box {
      min-width: 490px;
      position: relative;
      width: 100%;
      padding: 10px 0;
      overflow: hidden;
      .box-right {
        width: 100%;
        justify-content: space-around;
        display: flex;
        .echarsDemo {
          height: 170px;
          min-width: 250px;
        }
      }
    }
  }
}
</style>